/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Login_ErrorInputs */



/**

* @param {_Login_ErrorInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _login_error = /** @type {((inputs?: _Login_ErrorInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Login_ErrorInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Bei der Anmeldung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.")
});